import * as ActionTypes from './types';

export function getDepartmentsWithFilters(payload) {
    return {
        type: ActionTypes.GET_DEPARTMENTS_WITH_FILTERS,
        payload: payload
    }
}

export function getDepartmentsWithFiltersSuccess(payload) {
  return {
    type: ActionTypes.GET_DEPARTMENTS_WITH_FILTERS_SUCCESS,
    payload: payload
  }
}

export function getDepartmentsWithFiltersFailed(payload) {
  return {
    type: ActionTypes.GET_DEPARTMENTS_WITH_FILTERS_FAILED,
    payload: payload
  }
}

export function changeDepartmentsState(payload) {
    return {
        type: ActionTypes.CHANGE_DEPARTMENTS_STATE,
        payload: payload
    }
}

export function getDepartments(payload) {
  return {
    type: ActionTypes.GET_DEPARTMENTS,
    payload: payload
  }
}

export function getDepartmentsSuccess(payload) {
  return {
    type: ActionTypes.GET_DEPARTMENTS_SUCCESS,
    payload: payload
  }
}

export function getDepartmentsFailed(payload) {
  return {
    type: ActionTypes.GET_DEPARTMENTS_FAILED,
    payload: payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/departments.js